import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease: EASE, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal for headings. Pass an array of lines.
export const MaskedLines = ({ lines, className = "", lineClass = "", start = true, stagger = 0.12, delay = 0 }) => (
  <div className={className}>
    {lines.map((line, i) => (
      <span key={i} className="mask-line">
        <motion.span
          className={`block ${lineClass}`}
          initial={{ y: "110%" }}
          animate={start ? { y: "0%" } : {}}
          transition={{ duration: 1, ease: EASE, delay: delay + i * stagger }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </div>
);
